import { render, staticRenderFns } from "./CategoryDisplay.vue?vue&type=template&id=17cbb2c1&scoped=true&"
import script from "./CategoryDisplay.vue?vue&type=script&lang=js&"
export * from "./CategoryDisplay.vue?vue&type=script&lang=js&"
import style0 from "./CategoryDisplay.vue?vue&type=style&index=0&id=17cbb2c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17cbb2c1",
  null
  
)

component.options.__file = "CategoryDisplay.vue"
export default component.exports